const linksNav = [
  {
    id: 1,
    url: "/",
    text: "Domů",
  },
  {
    id: 2,
    url: "/movies",
    text: "Filmy",
  },
  {
    id: 3,
    url: "/slider",
    text: "Posuvník filmů",
  },
  {
    id: 4,
    url: "/generator",
    text: "Generátor lorem ipsum",
  },
  {
    id: 5,
    url: "/trainuseref",
    text: "Hook useRef",
  },
  {
    id: 6,
    url: "/faq",
    text: "FAQ",
  },
]


export default linksNav